import React, { useCallback, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { initSamFileUploadMetaData } from "userful-chronos-app-common-js/dist/models/sam/SAMUtils";
import { useTranslation } from "react-i18next";
import UploadFileExtensionValidation from "./uploadFileExtensionValidation";
import { faCloudArrowUp } from "@fortawesome/pro-regular-svg-icons";
import { SamFileUploadMetaData } from "userful-chronos-app-common-js/dist/models/sam/SAMAsset";
import { v4 as uuidv4 } from "uuid";

type Iprops = {
    hideTitle?: boolean;
    setSelectedFiles: (value: FileState[]) => void;
    setIsFilePicked: (value: boolean) => void;
};

interface FileState {
    file: File;
    fileName: string;
    metadata: SamFileUploadMetaData;
}

export default function FileDropZone(props: Iprops) {
    const inputID = useRef(`file-input-${uuidv4()}`);
    const [draggingOver, setDraggingOver] = useState(false);

    const handleClick = () => {
        document.getElementById(inputID.current)?.click();
    };

    const handleFiles = useCallback((files: FileList) => {
        const acceptedFiles = files ? Array.from(files) : [];
        const validFiles = acceptedFiles.filter((item) => UploadFileExtensionValidation(item.name));
        if (validFiles.length < 1) {
            toast.error(t("Sources&Destinations.Sources.UploadFile.invalidFiles"), {
                toastId: "file-upload-invalid-files",
                containerId: "uploadFileContainer",
            });
        } else {
            toast.dismiss("file-upload-invalid-files");
        }
        props.setSelectedFiles(
            validFiles.map((f) => ({
                file: f,
                fileName: f.name,
                metadata: {
                    ...initSamFileUploadMetaData(),
                    id: { value: uuidv4() },
                    name: f.name,
                    description: `Uploaded on ${new Date().toLocaleString()}`,
                },
            })),
        );
        props.setIsFilePicked(validFiles.length > 0);
    }, []);
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        handleFiles(event.target.files);
    };
    const handleDrop = useCallback((event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        handleFiles(event.dataTransfer.files);
    }, []);
    const dragEnter = useCallback((e: React.DragEvent<HTMLDivElement>) => {
        setDraggingOver(true);
    }, []);
    const dragLeave = useCallback((e: React.DragEvent<HTMLDivElement>) => {
        setDraggingOver(false);
    }, []);

    const { t } = useTranslation();

    return (
        <>
            <div
                className="upload-files-area"
                onDrop={handleDrop}
                onClick={handleClick}
                style={{ cursor: "pointer" }}
                onDragEnter={dragEnter}
                onDragLeave={dragLeave}
            >
                {draggingOver && (
                    <div className="fileDraggingOverlay">
                        {t("Sources&Destinations.Sources.UploadFile.DropFileHere")}
                    </div>
                )}
                <div>
                    {!props.hideTitle && (
                        <div className="text-heading">{t("Sources&Destinations.Sources.UploadFile.Addfile")}</div>
                    )}
                </div>
                <div className="upload-files">
                    <FontAwesomeIcon icon={faCloudArrowUp} />
                    <div>{t("Sources&Destinations.Sources.UploadFile.title")}</div>
                    <span>{t("Sources&Destinations.Sources.UploadFile.DragandDrop")}</span>
                    <span style={{ color: "#1F2747" }}>
                        {t("Sources&Destinations.Sources.UploadFile.or")}
                        <label className="custom-file-upload" style={{ marginLeft: "4px" }}>
                            {t("Sources&Destinations.Sources.UploadFile.BrowseManually")}
                        </label>
                    </span>
                </div>
                <input type="file" hidden id={inputID.current} onChange={handleFileChange} multiple />
            </div>
        </>
    );
}
